module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PHBhdGggZD0iTTE2Ljg5MiAxLjk4Mkg2Ljk3NEEyLjE0IDIuMTQgMCAwIDAgNC44MzYgNC4xMnYxNy4xNDhhLjc1Ljc1IDAgMCAwIDEuMjE4LjU4NWw1Ljg3OC00LjcxIDUuODc5IDQuNzFhLjc0NS43NDUgMCAwIDAgLjc5NC4wOTEuNzUuNzUgMCAwIDAgLjQyNS0uNjc2VjQuMTJhMi4xNCAyLjE0IDAgMCAwLTIuMTM4LTIuMTM4em0uNjM4IDE3LjcyNWwtNS4xMjktNC4xMDlhLjc0OC43NDggMCAwIDAtLjkzOCAwbC01LjEyOCA0LjEwOFY0LjEyYzAtLjM1Mi4yODYtLjYzOC42MzgtLjYzOGg5LjkxOGEuNjQuNjQgMCAwIDEgLjYzOS42Mzh2MTUuNTg3eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-bookmark.svg
// module id = 367
// module chunks = 1